import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

// pdfjs worker 설정 (필수)
pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.mjs`;

const PdfViewer = React.memo(({ pdf }) => {
  const [containerWidth, setContainerWidth] = useState(0);
  const [numPages, setNumPages] = useState(null);

  useEffect(() => {
    const updateWidth = () => {
      const wrapper = document.getElementById("pdf-container");
      if (wrapper) {
        setContainerWidth(wrapper.clientWidth);
      }
    };
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  return (
    <div
      id="pdf-container"
      style={{
        width: "100%",
        maxWidth: "768px",
        margin: "0 auto",
        padding: "24px 16px",
        boxSizing: "border-box",
        backgroundColor: "rgba(252, 246, 207, 0.5)",
      }}
    >
      <Document
        file={pdf}
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
        loading="로딩 중..."
      >
        {Array.from(new Array(numPages), (_, index) => (
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            width={containerWidth}
            style={{ marginBottom: "24px" }}
            renderAnnotationLayer={false}
            renderTextLayer={false}
          />
        ))}
      </Document>
    </div>
  );
});

export default PdfViewer;
